import { router } from "@inertiajs/react";
import { Plus, Trash2 } from "lucide-react";
import { useState } from "react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface AliasManagerProps {
  aliases: string[];
  addAliasUrl: string;
  removeAliasUrl: string;
}

export default function AliasManager({
  aliases,
  addAliasUrl,
  removeAliasUrl,
}: AliasManagerProps) {
  const [newAlias, setNewAlias] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddAlias = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!newAlias.trim()) {
      alert("Por favor ingresa un alias");
      return;
    }

    setIsSubmitting(true);
    
    router.post(
      addAliasUrl,
      { alias: newAlias.trim() },
      {
        preserveScroll: true,
        onSuccess: () => {
          setNewAlias("");
          setIsSubmitting(false);
        },
        onError: () => {
          setIsSubmitting(false);
        },
      }
    );
  };

  const handleRemoveAlias = (alias: string) => {
    if (!window.confirm(`¿Estás seguro de que deseas eliminar el alias "${alias}"?`)) {
      return;
    }

    router.delete(removeAliasUrl, {
      data: { alias },
      preserveScroll: true,
    });
  };

  return (
    <div className="space-y-4">
      {/* Existing Aliases */}
      {aliases && aliases.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {aliases.map((alias, index) => (
            <Badge key={index} variant="secondary" className="text-sm pr-1">
              {alias}
              <Button
                variant="ghost"
                size="sm"
                className="h-auto p-1 ml-2 hover:bg-destructive hover:text-destructive-foreground"
                onClick={() => handleRemoveAlias(alias)}
              >
                <Trash2 className="h-3 w-3" />
              </Button>
            </Badge>
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground text-sm">
          No hay alias registrados para este producto
        </p>
      )}

      {/* Add New Alias Form */}
      <form onSubmit={handleAddAlias} className="flex gap-2">
        <Input
          type="text"
          value={newAlias}
          onChange={(e) => setNewAlias(e.target.value)}
          placeholder="Agregar nuevo alias..."
          className="flex-1"
          disabled={isSubmitting}
        />
        <Button 
          type="submit" 
          size="sm"
          disabled={isSubmitting || !newAlias.trim()}
        >
          <Plus className="h-4 w-4 mr-1" />
          Agregar
        </Button>
      </form>
    </div>
  );
}